import { Controller } from 'stimulus'
import Rails, { $ } from '@rails/ujs'

export default class extends Controller {
  static targets = ['ownerCheckbox', 'ownerInput', 'ownerInfo', 'impact', 'impactLiveRegion', 'textareaContainer', 'attachCoverPhoto', 'removeCoverPhoto', 'coverFileName', 'coverPhotoRegion']

  connect() {
    this.toggleAddOwners()
    this.updateCoverPhoto()
  }

  toggleAddOwners() {
    if (this.hasOwnerCheckboxTarget) {
      this.ownerInputTarget.disabled = this.ownerCheckboxTarget.checked
      const label = $('label[for=' + this.ownerInputTarget.id + ']')[0]

      if (!this.hasOwnerInfoTarget) return

      if (this.ownerCheckboxTarget.checked) {
        this.ownerInfoTarget.innerHTML = 'Deselect organization to add team members & groups'
        label.classList.add('members-multiselect-gray-text')
      } else {
        this.ownerInfoTarget.innerHTML = 'You are automatically added to this Issue'
        label.classList.remove('members-multiselect-gray-text')
      }
    }
  }

  validateImpact() {
    let error = ''
    const charLimit = 150
    if (this.impactTarget.textLength > charLimit) {
      error = `Please enter an impact with ${charLimit} characters or fewer.`
    }
    const errorEvent = new CustomEvent('renderError', { detail: error })
    this.textareaContainerTarget.dispatchEvent(errorEvent)
  }

  deleteCoverPhoto() {
    Rails.ajax({
      type: 'delete',
      url: '/issues/cover_photo',
      data: `id=${event.target.dataset.id}`
    })
  }

  removeCoverPhoto() {
    this.attachCoverPhotoTarget.value = ''
    this.coverPhotoRegionTarget.innerHTML = ''
    this.updateCoverPhoto()
    this.enableSubmit()
  }

  updateCoverPhoto() {
    if (this.hasAttachCoverPhotoTarget) {
      this.coverFileNameTarget.innerHTML = this.attachCoverPhotoTarget.value
        ? this.attachCoverPhotoTarget.value.replace(/^.*[\\/]/, '')
        : ''
      this.removeCoverPhotoTarget.style.visibility = this.attachCoverPhotoTarget.value ? 'visible' : 'hidden'
      this.attachCoverPhotoTarget.value && this.photoValidation(this.attachCoverPhotoTarget.files[0])
    }
  }

  photoValidation(file) {
    let ul = '<ul>'
    if (file.size >= 36700160) {
      ul += '<li>Please upload an image less than 35 MB</li>'
    }
    if (!['image/png', 'image/jpg', 'image/gif', 'image/jpeg'].includes(file.type)) {
      ul += '<li>Please upload an image file.</li>'
    }
    ul += '</ul>'

    this.coverPhotoRegionTarget.innerHTML = ul
    if (ul.includes('<li>')) {
      this.disableSubmit()
    } else {
      this.enableSubmit()
    }
  }

  disableSubmit() {
    const buttonSubmit = document.querySelector('button[type="submit"]')
    const inputSubmit = document.querySelector('input[type="submit"]')
    if (buttonSubmit) {
      buttonSubmit.disabled = true
    }
    if (inputSubmit) {
      inputSubmit.disabled = true
    }
  }

  enableSubmit() {
    const buttonSubmit = document.querySelector('button[type="submit"]')
    const inputSubmit = document.querySelector('input[type="submit"]')
    if (buttonSubmit) {
      buttonSubmit.disabled = false
    }
    if (inputSubmit) {
      inputSubmit.disabled = false
    }
  }
}
